import React, { memo } from 'react';
import {
    ALERT_SUCCESS,
    ALERT_ERROR,
} from '@client/redux/modules/successOverlay/constants';
import { CheckIcon, ErrorIcon } from '@client/components/shared/SvgIcons';
import { Text, TextPreset } from '@pegasus/ui-components/components/text';
import { Wrapper, IconWrapper } from './DoiSuccessAlert.styles';

interface DoiSuccessAlertProps {
    type: typeof ALERT_SUCCESS | typeof ALERT_ERROR;
    message: string;
}
const DoiSuccessAlert = memo(({ type, message }: DoiSuccessAlertProps) => {
    const Icon = type === ALERT_SUCCESS ? CheckIcon : ErrorIcon;

    return (
        <Wrapper>
            <IconWrapper>
                <Icon />
            </IconWrapper>
            <Text preset={TextPreset.S}>{message}</Text>
        </Wrapper>
    );
});

export default DoiSuccessAlert;
